import {FormControl, FormGroupDirective, NgForm} from "@angular/forms";
import {ErrorStateMatcher} from "@angular/material/core";

/**
 * Reveals a field's validation error as soon as the control is invalid, regardless of whether the user
 * has touched or changed it. Use for controls whose value is set programmatically (pre-filled or patched
 * from the store): Angular Material's default matcher only shows the error once the control is
 * touched/dirty or the form is submitted, so a pre-filled-but-invalid value would stay silently invalid.
 */
export class ImmediateErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
        return !!(control && control.invalid);
    }
}

/**
 * Shared singleton of {@link ImmediateErrorStateMatcher}. The matcher is stateless, so reuse this
 * instance across components (e.g. for a pre-filled closing-date control) instead of instantiating one
 * per component.
 */
export const IMMEDIATE_ERROR_STATE_MATCHER = new ImmediateErrorStateMatcher();
